import { usersBusiness } from "api/bussiness/user-role-permission/users-bussiness";
import { GetUsers } from "api/models/request/user-role/users";
import { applySnapshot, flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";
import { Pagination } from "../../api/models/response/pagination";
import { withSetPropAction } from "../_extension/with-set-props";
import { IUserProperties, User } from "../_models/user-roles/user";
import { PaginationStore } from "./common/pagination-store";

export const UserManagement = types
  .model({
    users: types.optional(types.array(User), []),
    pagination: types.optional(PaginationStore, {}),
    userSelected: types.maybeNull(User),
    openNew: false,
    openEdit: false,
    openDelete: false,
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getUsers: flow(function* getUsers(request: GetUsers) {
      try {
        self._rootStore.setProp("inProgress", true);
        const userRes = (yield usersBusiness.getUsers(
          request
        )) as Pagination<IUserProperties>;
        self.setProp("users", userRes.items);
        self.pagination.setProp("totalItems", userRes.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }))
  .actions((self) => ({
    replaceUser: (replaceUser: IUserProperties) => {
      const user = self.users.filter((x) => x.id === replaceUser.id)?.[0];
      applySnapshot(user, replaceUser);
    },
  }));
